export default __webpack_public_path__ + "static/media/_default-avatar-dark.fa80f65d.svg";